import { ProjectInfo } from '@frontend-site/shared/data';
import { MenuItem } from '../../../models';
import { MENU_IDS } from '../../menu-ids';

export function createReportsMenu(projectInfo: ProjectInfo): MenuItem | null {
    if (!showReports(projectInfo)) {
        return null;
    }

    return {
        id: MENU_IDS.PROJECT.REPORTS,
        label: 'Enumerations.ApplicationModules.REPORTS',
        routePath: `/tm/${projectInfo.id}/reports`
    };
}

export function showReports(projectInfo: ProjectInfo): boolean {
    if (projectInfo.isRestrictedApp()) {
        return false;
    }
    if (projectInfo.isSalesforceProject()) {
        if (projectInfo.hasTestsModule()) {
            return true;
        } else {
            return false;
        }
    }

    return !projectInfo.qc;
}
